import React, { PureComponent } from 'react'
import Utils from 'live/lib/utils'
import i18n from 'live/services/i18n'
import styled from 'styled-components'
import ReactDOM from 'react-dom'
import Annotation from '../annotations/annotation'
import Modal from 'live/components/ui/Modal'

class AnnotationService {

    rendered = false
    root?: HTMLElement

    constructor (url: string) {
        this.root = document.createElement('div')

        document.body.appendChild(this.root)

        window.Live.openAnnotation = this.showAnnotation
    }

    showAnnotation = annotation => {
        ReactDOM.render(<AnnotationModal onHide={this.onHide} annotation={annotation} />, this.root)
    }

    onHide = a => {
        this.rendered = false
        ReactDOM.unmountComponentAtNode(this.root)
    }

}

const annotationService = new AnnotationService()

export default annotationService

class AnnotationModal extends PureComponent {

    state = {
        edit: false
    }

    submitFn = console.warn.bind(null, 'No submit function lifted.')

    onEdit = (event, form) => {
        this.setState({
            edit: true,
            FormComponent: form.component,
            editingEvent: { ...this.props.annotation }
        })
    }

    renderEdit = () => {
        const { FormComponent, editingEvent } = this.state

        return (
            <FormComponent
                onHide={annotation => {
                    this.setState({
                        annotation: annotation && annotation.uid ? annotation : null,
                        edit: false
                    })
                }}
                liftSubmitFn={fn => (this.submitFn = fn)}
                event={editingEvent}
                showActions={true}
            />
        )
    }

    renderView = () => {
        return (
            <Annotation
                onDelete={this.props.onHide}
                expanded={true}
                event={this.state.annotation || this.props.annotation}
                onEdit={this.onEdit}
            />
        )
    }

    render () {
        const { edit } = this.state
        const { onHide } = this.props

        return (
            <Modal backdrop="static" keyboard={false} onHide={onHide} show={true}>
                <Modal.Body style={{ background: 'transparent' }}>
                    <React.Fragment>{edit ? this.renderEdit() : this.renderView()}</React.Fragment>
                </Modal.Body>
                {!edit && (
                    <Modal.Footer>
                        <button className="btn btn-default" onClick={onHide}>
                            {i18n('Close')}
                        </button>
                    </Modal.Footer>
                )}
            </Modal>
        )
    }

}
